import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, Subscriber } from 'rxjs';

import * as Models from 'appshared/shared-models';
import { PartnerAdminService } from './partner-admin.service';

// this thing (a resolve) will run before a route is routed
// basically, grab the items from the service

@Injectable({ providedIn: 'root' })
export class PartnersResolverService implements Resolve<Models.Partnership[]> {
	constructor(private objService: PartnerAdminService) { }

	resolve(): Observable<Models.Partnership[]> | Observable<never> | Models.Partnership[] {
		// check to see if the items have ever been loaded.  If not, load'em
		if (this.objService.loaded) {
			// console.log('in resolver - the list is alive!');
			return this.objService.getAll();
		} else {
			// console.log('in resolver - need a new list');
			return new Observable((observe: Subscriber<Models.Partnership[]>) => {
				this.objService.refreshAll().subscribe((items: Models.Partnership[]) => {
					observe.next(items);
					observe.complete();
				});
			});
		}
	}
}

